<template>
  <Card>
    <div slot="title">
      <span class="title-text">{{obj.header}}</span>
      <span class="title-number">{{obj.number}}</span>
    </div>
    <span class="title-more" slot="extra">查看全部</span>
    <!-- 临时 -->
    <div class="tmp">即将上线...</div>
    <div class="card-item" v-for="(item,index) in obj.dataList" :key="index" :data-index="index">
      <div class="card-left">
        <div class="card-img">
          <img :src="item.imgUrl">
        </div>
        <div class="card-content">
          <div class="content-title">
            {{item.title}}
          </div>
          <div class="content-state" >
            三会一课
          </div>
        </div>
      </div>
      <div class="card-right">{{item.time}}</div>
    </div>

  </Card>
</template>

<script>
export default {
  props: ["obj"],
  data() {
    return {};
  },
  methods: {},
  components: {}
};
</script>

<style lang="less" scoped>
.tmp{
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #666;
  min-height: 100px;
}
/* 标题栏 开始*/
.title-text {
  font-size: 18px;
  color: #333;
  margin-right: 10px;
}
.title-number {
  font-size: 18px;
  color: #999;
}
.title-more {
  color: #546fb4;
  font-size: 14px;
}
/* 内容区域 */
.icard {
}
// 分割线 card-body 的padding
.card-item {
  display: flex;
  justify-content: space-between;
  position: relative;
  margin: 40px 0;
  &:first-child {
    margin-top: 0px;
  }
  &:last-child{
    margin-bottom: 0px;
  }
  &:last-child::after{
    content:none;
  }
}

.card-item::after {
  content: "";
  position: absolute;
  height: 2px;
  width: calc(~"100% + 34px");
  margin-left: -18px;
  background-color: #eee;
  bottom: -20px;
}
/* 左侧 */
.card-left{
  display: flex;
}
.card-img{
  width: 100px;
  height: 72px;
  line-height: 72px;
  background-color: rgba(0, 0, 0, 0.1);
  text-align: center;
  &>img{
    height: 100%;
    width: auto;
  }
}
.card-content{
  padding-top: 8px;
  margin-left: 20px;
}
.content-title{
  font-size: 14px;
  color: #666;
  margin-bottom: 1em;
}
.content-state{
  font-size: 14px;
  color: #fd7c42;
}
/* 右侧 */
.card-right{
  padding-top: 8px;
  color: #999;
}
</style>

